import { getGA4Context } from '../../helpers';
import { tracker } from '../track';
export const trackSelectFilter = ({ element, context, filterLvl, filtersValue, length, campaignId, }) => {
    const selectFilter = {
        context: context || getGA4Context(),
        element,
        filter_lvl: filterLvl === 0 ? 0 : filterLvl || null,
        filters_value: filtersValue,
        length: length || null,
        promotion_id: campaignId || null,
    };
    tracker.track('GA4-select_filter', {
        event_name: 'select_filter',
        select_filter: selectFilter,
    });
};
